var config = {};

config.web = {};
config.web.server_base = 'hc.rebuild.digital';
config.web.server_protocol = 'https';

module.exports = config;
